import { useNavigate } from 'react-router-dom'
import { Button } from '../ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'

interface RejectModalProps {
  isOpen: boolean
  onClose: () => void
}

export default function RejectModal({ isOpen, onClose }: RejectModalProps) {
  const navigate = useNavigate()

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <Card className="w-full max-w-md mx-4">
        <CardHeader className="pb-4">
          <CardTitle className="text-xl font-bold text-gray-900 text-center">
            IMPORTANT
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <p className="text-gray-700 leading-relaxed">
            By selecting and then clicking on the{' '}
            <span className="font-medium text-red-600">DECLINE</span> button I
            indicate that I do not wish to join and I do not wish to access the
            Ecosystem.
          </p>
          <div className="flex justify-between pt-4">
            <Button
              type="button"
              variant="outline"
              className="px-6 py-2 border-gray-300 text-gray-700 hover:bg-gray-50"
              onClick={onClose}
            >
              Go Back
            </Button>
            <Button
              type="button"
              className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white"
              onClick={() => navigate('/')}
            >
              DECLINE
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
